/* global gdAlertify */
import React from "react";
import BuscarAuxiliar from "./BuscarAuxiliar";
import {
    buildNoEnviarWarningMessage,
    formatAuxiliarSearchLabel,
    getNoEnviarPacienteStatus,
} from "../../utils/noEnviarPaciente";

function ModalBusquedaAuxiliar({
    isOpen,
    onClose,
    onSelect,
    pacienteAuxiliares = [],
    excludeAuxiliarID = null,
    pacienteID = null,
    pacienteNombre = "",
}) {
    const hasActiveAgreement = (auxiliar = {}) => {
        const value = auxiliar.tiene_acuerdo ?? auxiliar.tieneAcuerdo ?? auxiliar.acuerdo_activo ?? auxiliar.acuerdoActivo;
        if (value !== undefined && value !== null) {
            return value === true || value === 1 || value === "1" || String(value).toLowerCase() === "true";
        }

        return !!(auxiliar.idAcuerdo || auxiliar.id_acuerdo || auxiliar.acuerdoID || auxiliar.acuerdoId);
    };

    const handleSeleccionar = (row) => {
        const noEnviarStatus = getNoEnviarPacienteStatus(row);

        if (noEnviarStatus.active) {
            gdAlertify.notify(
                buildNoEnviarWarningMessage({
                    auxiliar: row,
                    pacienteNombre,
                }),
                "warning"
            );
            return;
        }

        onSelect(row);
        onClose();
    };

    if (!isOpen) return null;

    const auxiliaresAcuerdoActivo = pacienteAuxiliares.filter(hasActiveAgreement);
    const acuerdoActivoIds = new Set(auxiliaresAcuerdoActivo.map((auxiliar) => auxiliar.id));
    const auxiliaresHistoricos = pacienteAuxiliares.filter((auxiliar) => !acuerdoActivoIds.has(auxiliar.id));

    const renderAuxiliarList = (items, emptyText) => (
        items.length === 0 ? (
            <div className="alert alert-info mb-0">
                <i className="fas fa-info-circle me-2"></i>
                {emptyText}
            </div>
        ) : (
            <div className="list-group">
                {items.map((auxiliar) => {
                    const isExcluded = auxiliar.id === excludeAuxiliarID;
                    const noEnviarStatus = getNoEnviarPacienteStatus(auxiliar);
                    const isBlocked = isExcluded || noEnviarStatus.active;
                    return (
                        <div
                            key={auxiliar.id}
                            className={`list-group-item ${isBlocked ? 'list-group-item-secondary' : 'list-group-item-action'}`}
                            style={{
                                cursor: isBlocked ? 'not-allowed' : 'pointer',
                                opacity: isBlocked ? 0.6 : 1
                            }}
                            onClick={() => !isBlocked && handleSeleccionar(auxiliar)}
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <div className={isBlocked ? 'text-decoration-line-through' : ''}>
                                    <strong>
                                        {formatAuxiliarSearchLabel(auxiliar, {
                                            includeNoEnviarSuffix: false,
                                            includeRut: false,
                                        })}
                                    </strong>
                                    <br />
                                    <small className="text-muted">
                                        <i className="fas fa-id-card me-1"></i>
                                        RUT: {auxiliar.rut}
                                        {auxiliar.celular && (
                                            <>
                                                <span className="mx-2">|</span>
                                                <i className="fas fa-phone me-1"></i>
                                                {auxiliar.celular}
                                            </>
                                        )}
                                        {auxiliar.des_categoria && (
                                            <>
                                                <span className="mx-2">|</span>
                                                <i className="fas fa-star me-1"></i>
                                                {auxiliar.des_categoria}
                                            </>
                                        )}
                                    </small>
                                    {noEnviarStatus.active && (
                                        <div className="small text-warning mt-2">
                                            <i className="bi bi-exclamation-triangle me-1"></i>
                                            {noEnviarStatus.observation || "Marcado como NO ENVIAR A ESTE DOMICILIO."}
                                        </div>
                                    )}
                                </div>
                                <div className="d-flex flex-column align-items-end gap-2">
                                    {hasActiveAgreement(auxiliar) && (
                                        <span className="badge bg-success">
                                            Acuerdo activo
                                        </span>
                                    )}
                                    {noEnviarStatus.active && (
                                        <span className="badge bg-warning text-dark">
                                            <i className="fas fa-ban me-1"></i>
                                            NO ENVIAR A ESTE DOMICILIO
                                        </span>
                                    )}
                                    {isExcluded && (
                                        <span className="badge bg-secondary">
                                            <i className="fas fa-user-lock me-1"></i>
                                            Auxiliar de la solicitud
                                        </span>
                                    )}
                                    {!isBlocked && (
                                        <button
                                            className="btn btn-sm btn-success"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleSeleccionar(auxiliar);
                                            }}
                                        >
                                            <i className="fas fa-check me-1"></i>
                                            Seleccionar
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        )
    );

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" aria-labelledby="busquedaAuxiliarModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="busquedaAuxiliarModalLabel">Búsqueda de Auxiliar</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid">
                            {/* Buscador de Auxiliar */}
                            <BuscarAuxiliar
                                onSelect={handleSeleccionar}
                                titulo="Buscar Auxiliar por Nombre o RUT"
                                pacienteId={pacienteID}
                                pacienteNombre={pacienteNombre}
                                blockNoEnviar={true}
                            />

                            {/* Divider */}
                            <div className="d-flex align-items-center my-4">
                                <hr className="flex-grow-1" />
                                <span className="mx-3 text-muted">O selecciona de la lista</span>
                                <hr className="flex-grow-1" />
                            </div>

                            <div className="card mb-3">
                                <div className="card-header bg-light">
                                    <h6 className="mb-0">
                                        <i className="fas fa-file-contract me-2"></i>
                                        Auxiliares con acuerdo activo
                                        {auxiliaresAcuerdoActivo.length > 0 && (
                                            <span className="badge bg-success ms-2">
                                                {auxiliaresAcuerdoActivo.length}
                                            </span>
                                        )}
                                    </h6>
                                </div>
                                <div className="card-body">
                                    {renderAuxiliarList(auxiliaresAcuerdoActivo, "No hay auxiliares con acuerdo activo.")}
                                </div>
                            </div>

                            {/* Lista de Auxiliares del Paciente */}
                            <div className="card">
                                <div className="card-header bg-light">
                                    <h6 className="mb-0">
                                        <i className="fas fa-user-friends me-2"></i>
                                        Auxiliares que han trabajado con este paciente
                                        {auxiliaresHistoricos.length > 0 && (
                                            <span className="badge bg-primary ms-2">
                                                {auxiliaresHistoricos.length}
                                            </span>
                                        )}
                                    </h6>
                                </div>
                                <div className="card-body">
                                    {renderAuxiliarList(auxiliaresHistoricos, "No hay auxiliares registrados para este paciente.")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalBusquedaAuxiliar;
